<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.outInInventory.new')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/outInInventory">
              <span>{{$t('tlt.inventory.outInInventory')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/outInInventory/edit">
              <span>{{$t('tlt.outInInventory.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('outIn')"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <button class="btn btn-primary" type="button" v-on:click="MMFSave('outIn')">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.basic.matName')}}:
                </label>
                <dimSearch
                  validate="required"
                  name="matName"
                  v-model="matName"
                  :entity="materials"
                   submitProp="matName"
                  bindProp="matName"
                  bindId="material"
                ></dimSearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.basic.matCode')}}:
                </label>
                <dimSearch
                  validate="required"
                  name="matCode"
                  v-model="matCode"
                  :entity="materials"
                  submitProp="matCode"
                  bindProp="matCode"
                  bindId="material"
                ></dimSearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.inventory.outInClass')}}:</label>
                <select class="form-control" v-model="outInClass">
                  <option value="O">{{ $t("lbl.inventory.out") }}</option>
                  <option value="I">{{ $t("lbl.inventory.in") }}</option>
                  <!-- <option value="ALL">{{ $t("lbl.inventory.all") }}</option> -->
                </select>
              </div>
              <div class="form-group col-md-2">
                <!-- style="display: none" -->
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.inventory.invName')}}:
                </label>
                <dimSearch
                  validate="required"
                  name="locName"
                  v-model="invName"
                  :entity="locations"
                  submitProp="locName"
                  bindProp="locName"
                  bindId="location"
                ></dimSearch>
              </div>
              <div class="form-group col-md-2">
                <!-- style="display: none" -->
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.inventory.invCode')}}:
                </label>
                <dimSearch
                  validate="required"
                  name="code"
                  v-model="invCode"
                  :entity="locations"
                  submitProp="code"
                  bindProp="code"
                  bindId="location"
                ></dimSearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.inventory.outInQuantity')}}:
                </label>
                <input class="form-control form-control-sm" v-model="outInQuantity" type="text" />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.inventory.outInTime')}}：
                </label>
                <mmf-datetimepicker v-model="outInTime"></mmf-datetimepicker>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>



<script>
import { createHelpers } from "vuex-map-fields";
import { mapActions, mapState } from "vuex";
import { fields } from "@/model/prd/inventoryMgt/OutIn";
import dimSearch from "@/components/MMFDimSearch";
import MmfDatetimepicker from "@/components/MmfDatetimepicker";

const { mapFields } = createHelpers({
  getterType: "outIn/getField",
  mutationType: "outIn/updateField"
});
export default {
  data() {
    return {
      materials: [],
      locations: [],
     

      // locations : []
    };
  },
  // beforeMount() {
  //   this.$store.dispatch("downtimePlan/loadLocations");
  // },
  computed: {
    ...mapFields(fields),
    ...mapState({
      // locations: state => state.outIn.locations,
      rows: state => state.outIn.rows,
      entity: state => state.outIn.entity
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave"])
  },
  components: {
    dimSearch,
    MmfDatetimepicker,
  },
  mounted() {
    //自动加载页面 this.MMFLoadRows("rawMaterial");
    this.$store
      .dispatch(
        "api/get",
        {
          url: this.$store.state.location.baseModuleUrl + "/material/findAll"
        },
        {
          root: true
        }
      )
      .then(data => {
        data.push({});
        this.materials = data;
      }),
      this.$store
        .dispatch(
          "api/get",
          {
            url:
              this.$store.state.location.baseModuleUrl + "/location/findByPerId"
          },
          {
            root: true
          }
        )
        .then(data => {
          data.push({});
          this.locations = data;
        });
  }
};
</script>